import { NavbarLogin } from "../../components/navigation/NavbarLogin";
import { Primary } from "../../components/buttons/Primary";
import { LockClosedIcon } from "@heroicons/react/24/solid";

export function PayHome() {
  return (
    <>
      <NavbarLogin />
      <div className="bg-red bg-opacity-10 overflow-hidden pt-10 font-walsheim">
        <div className="pt-6 pb-16 sm:pb-24">
          <main className="mt-16 sm:mt-18">
            <div className="mx-12 bg-white h-full rounded-md">
              <div className="lg:grid lg:grid-cols-12 lg:gap-8">
                <div className="sm:px-6 py-1 sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left lg:flex lg:items-center">
                  <div className="mx-14 my-24">
                    <h1 className="text-2xl tracking-tight font-bold mt-5 lg:text-3xl">
                      <span className="md:block">
                        Paga tu cuota de manera fácil y sencilla por pse o
                        corresponsal Bancolombia.
                      </span>{" "}
                    </h1>
                    <div className="max-w-sm">
                      <p className="py-8 text-lg">
                        Digíta tu número de cédula para consultar tu saldo y
                        comenzar el proceso.
                      </p>
                      <form action="#">
                        <div>
                          <label
                            htmlFor="first-name"
                            className="block text-sm font-medium"
                          >
                            Número de documento
                          </label>
                          <div>
                            <input
                              type="number"
                              name="documento"
                              id="documento"
                              autoComplete="off"
                              spellcheck="false"
                              required="true"
                              minlength="6"
                              maxlength="10"
                              pattern="[0-9]+"
                              className="py-2 px-4 w-full border-0 border-b-2 border-opacity-20 border-tdark focus:border-purple focus:ring-0 sm:text-base"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                    <div className="pt-10 max-w-sm md:w-1/2">
                    <Primary text={"Continuar"}/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
